import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "src/environments/environment";
import { SpaceType } from "../../_types/space-type";
import { Equipment, EquipmentIcon } from "./equipment.model";

const url = environment.api;

@Injectable({
  providedIn: "root",
})
export class EquipmentService {
  constructor(
    private http: HttpClient,
    private translateService: TranslateService
  ) {}

  iconsList: EquipmentIcon[] = [
    {
      name: this.translateService.instant("EQUIPMENT.PROJECTOR"),
      iconName: "projector",
      value: "projector",
      icon: "../../assets/icons/equipment/projector.svg",
      SpaceType: SpaceType.Room,
    },
    {
      name: this.translateService.instant("EQUIPMENT.FLIPCHART"),
      iconName: "flipchart",
      value: "flipchart",
      icon: "../../assets/icons/equipment/flipchart.svg",
      SpaceType: SpaceType.Room,
    },
    {
      name: this.translateService.instant("EQUIPMENT.MULTIMEDIA_SCREEN"),
      iconName: "multimedia-screen",
      value: "multimedia-screen",
      icon: "../../assets/icons/equipment/multimedia-screen.svg",
      SpaceType: SpaceType.Room,
    },
    {
      name: this.translateService.instant("EQUIPMENT.KONFERENCE"),
      iconName: "conference-equipment",
      value: "conference-equipment",
      icon: "../../assets/icons/equipment/conference-equipment.svg",
      SpaceType: SpaceType.Room,
    },
    {
      name: this.translateService.instant("EQUIPMENT.AIR_CONDITION"),
      iconName: "air-condition",
      value: "air-condition",
      icon: " ../../assets/icons/equipment/air-condition.svg",
      SpaceType: SpaceType.Room,
    },
    {
      name: this.translateService.instant("EQUIPMENT.SOUND_SYSTEM"),
      iconName: "sound-system",
      value: "sound-system",
      icon: " ../../assets/icons/equipment/sound-system.svg",
      SpaceType: SpaceType.Room,
    },
    {
      name: this.translateService.instant("EQUIPMENT.STANDING_DESK"),
      iconName: "standing-desk",
      value: "standing-desk",
      icon: " ../../assets/icons/equipment/standing-desk.png",
      SpaceType: SpaceType.Desk,
    },
    {
      name: this.translateService.instant("EQUIPMENT.CAMERA"),
      iconName: "camera",
      value: "camera",
      icon: " ../../assets/icons/equipment/camera.svg",
      SpaceType: SpaceType.Desk,
    },
    {
      name: this.translateService.instant("EQUIPMENT.CORNER_DESK"),
      iconName: "corner-desk",
      value: "corner-desk",
      icon: " ../../assets/icons/equipment/corner-desk.svg",
      SpaceType: SpaceType.Desk,
    },
    {
      name: this.translateService.instant("EQUIPMENT.DESKTOP"),
      iconName: "desktop",
      value: "desktop",
      icon: " ../../assets/icons/equipment/desktop.svg",
      SpaceType: SpaceType.Desk,
    },
    {
      name: this.translateService.instant("EQUIPMENT.DOCKING_STATION"),
      iconName: "docking-station",
      value: "docking-station",
      icon: " ../../assets/icons/equipment/docking-station.svg",
      SpaceType: SpaceType.Desk,
    },
    {
      name: this.translateService.instant("EQUIPMENT.ERGONOMIC_CHAIR"),
      iconName: "ergonomic-chair",
      value: "ergonomic-chair",
      icon: " ../../assets/icons/equipment/ergonomic-chair.svg",
      SpaceType: SpaceType.Desk,
    },
    {
      name: this.translateService.instant("EQUIPMENT.EXTENSION_DESK"),
      iconName: "extension-desk",
      value: "extension-desk",
      icon: " ../../assets/icons/equipment/extension-desk.svg",
      SpaceType: SpaceType.Desk,
    },
    {
      name: this.translateService.instant("EQUIPMENT.HEADSET"),
      iconName: "headset",
      value: "headset",
      icon: " ../../assets/icons/equipment/headset.svg",
      SpaceType: SpaceType.Desk,
    },
    {
      name: this.translateService.instant("EQUIPMENT.KEYBOARD"),
      iconName: "keyboard",
      value: "keyboard",
      icon: " ../../assets/icons/equipment/keyboard.svg",
      SpaceType: SpaceType.Desk,
    },
    {
      name: this.translateService.instant("EQUIPMENT.LIFTED_DESK"),
      iconName: "lifted-desk",
      value: "lifted-desk",
      icon: " ../../assets/icons/equipment/lifted-desk.svg",
      SpaceType: SpaceType.Desk,
    },
    {
      name: this.translateService.instant("EQUIPMENT.MONITOR"),
      iconName: "monitor",
      value: "monitor",
      icon: " ../../assets/icons/equipment/monitor.svg",
      SpaceType: SpaceType.Desk,
    },
    {
      name: this.translateService.instant("EQUIPMENT.MOUSE"),
      iconName: "mouse",
      value: "mouse",
      icon: " ../../assets/icons/equipment/mouse.svg",
      SpaceType: SpaceType.Desk,
    },
    {
      name: this.translateService.instant("EQUIPMENT.PHONE_CHARGER"),
      iconName: "phone-charger",
      value: "phone-charger",
      icon: " ../../assets/icons/equipment/phone-charger.svg",
      SpaceType: SpaceType.Desk,
    },
    {
      name: this.translateService.instant("EQUIPMENT.SQUARE_DESK"),
      iconName: "square-desk",
      value: "square-desk",
      icon: " ../../assets/icons/equipment/square-desk.svg",
      SpaceType: SpaceType.Desk,
    },
    {
      name: this.translateService.instant("EQUIPMENT.TABLE_TOP_REGULATION"),
      iconName: "table-top-regulation",
      value: "table-top-regulation",
      icon: " ../../assets/icons/equipment/table-top-regulation.svg",
      SpaceType: SpaceType.Desk,
    },
  ];

  equipment: Equipment;
  equipments: Equipment[] = [];

  filteredIconsList: EquipmentIcon[];

  filterIcons(spaceType: SpaceType) {
    this.filteredIconsList = this.iconsList.filter(
      (el) => el.SpaceType == spaceType
    );
  }

  loadEquipmentsSync(reload: boolean = false, spaceType: SpaceType) {
    if (this.equipments.length === 0 || reload) {
      return this.getEquipments(spaceType)
        .toPromise()
        .then((equipments: Equipment[]) => {
          this.equipments = equipments;
        });
    }
  }

  getEquipments(spaceType: SpaceType) {
    return this.http.get(url + "equipment?type=" + spaceType);
  }

  loadEquipments(spaceType: SpaceType) {
    this.getEquipments(spaceType).subscribe((res: Equipment[]) => {
      this.equipments = res;
    });
  }

  getEquipment(id: number) {
    return this.http.get(url + "equipment/" + id);
  }

  createEquipment(equipment: Equipment) {
    return this.http.post(url + "equipment", equipment);
  }

  updateEquipment() {
    return this.http.put(
      url + "equipment/" + this.equipment.id,
      this.equipment
    );
  }

  deleteEquipment(id: number) {
    return this.http.delete(url + "equipment/" + id);
  }
}
